import {useEffect} from "react";
import {useSessionStorage} from "./hooks/useSessionStorage";
import {EmailForm} from "./EmailForm";
import {OtpForm} from "./OtpForm";
import {getBrowserClient} from "@/lib/supabase.ts";

const supabase = getBrowserClient();

export default function EmailLogin() {
  const {item: otpSentItem, setItem: setOtpSentItem} = useSessionStorage("login_otp_sent");
  const {item: emailItem, setItem: setEmailItem} = useSessionStorage("login_email");

  const otpSent = otpSentItem ? JSON.parse(otpSentItem) : false;
  const email = emailItem ? JSON.parse(emailItem) : "";

  // 認証状態を監視してログイン成功時にsessionStorageをクリア
  useEffect(() => {
    const {
      data: {subscription},
    } = supabase.auth.onAuthStateChange((event) => {
      if (event === "SIGNED_IN") {
        console.log("認証成功イベント検出 - sessionStorageをクリア");
        sessionStorage.removeItem("login_otp_sent");
        sessionStorage.removeItem("login_email");
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  const handleOtpSent = () => {
    setOtpSentItem(true);
  };

  const handleEmailChange = (newEmail: string) => {
    setEmailItem(newEmail);
  };

  const handleCancel = () => {
    setOtpSentItem(false);
  };

  const handleLoginSuccess = () => {
    console.log("ログイン成功");
    // 認証イベントで自動的にクリアされるため、ここでは何もしない
  };

  return (
    <div className="flex flex-col gap-6">
      <div key={otpSent ? "otp" : "email"} className="animate-fade-in-scale">
        {!otpSent ? <EmailForm onOtpSent={handleOtpSent} onEmailChange={handleEmailChange} /> : <OtpForm email={email} onCancel={handleCancel} onLoginSuccess={handleLoginSuccess} />}
      </div>
    </div>
  );
}
